import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'
import { EvidenceChip } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip'
import { useDocumentSearchData } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/DocumentSearchDataContext'
import type { ResponseSegment } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import { resolveCitationDocument } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/resolveCitationDocument'
import { usePipelineConfig } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { useSearchActions } from 'features/knowledgeDocumentViewer/contexts/SearchActionsContext'
import React from 'react'
import styled from 'styled-components'

const EvidenceChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
`

export function ResponseSegmentCitations({
  citations,
  citationLookup,
}: {
  citations: ResponseSegment['citations']
  citationLookup: Map<string, DocumentTableRow>
}): React.ReactElement | null {
  const { onOpenNewTab } = useSearchActions()
  const { documentResults } = useDocumentSearchData()
  const { selectedPipelineConfigId } = usePipelineConfig()

  if (citations.length === 0) return null

  return (
    <EvidenceChipRow>
      {citations.map((citation, citationIndex) => {
        const row = resolveCitationDocument({
          citationDocumentId: citation.document_id,
          documentResults,
          pipelineConfigId: selectedPipelineConfigId,
          lookup: citationLookup,
        })
        return (
          <EvidenceChip
            key={`${citation.page_id}-${citationIndex}`}
            documentId={row?.id}
            title={row ? row.documentTitle || row.title : undefined}
            drawing={row?.drawing ?? undefined}
            filename={row?.filename}
            bqDocumentId={row?.bqDocumentId}
            cantileverDocumentId={row?.cantileverDocumentId}
            documentHostsHydrated={Boolean(row)}
            pageNum={citation.page_num}
            quote={citation.quote}
            onClick={
              row
                ? () =>
                    onOpenNewTab({
                      documentId: row.id,
                      pageNumber: citation.page_num,
                    })
                : undefined
            }
          />
        )
      })}
    </EvidenceChipRow>
  )
}
